<template>
    <div>
          <section class="eventdetail" v-if="classPopup">
  <!-- {{eachEventInfo}} -->
      <div class="meetup-header mb-8">
          <div class="meetup_inner_holder">
            <div class="meetup-day">
              <h6 class="mb-0">
                {{ $moment(eventDetails.start,'DD/MM/YYYY').format("MMMM") }}
              </h6>
              <h3 class="mb-0">{{ $moment(eventDetails.start,'DD/MM/YYYY').format("D") }}</h3>
            </div>
            <div class="my-auto w-full">
             
  
              <div class="flex flex-wrap items-center my-2">
                <div class="sm:w-1/2 w-full my-2">
                  <div class="flex items-center my-2 mr-3">
                    <div class="badge-avatar">
                      <span class="material-icons-outlined">school</span>
                    </div>
                    <div class="ml-2">
                      <h6 style="font-size: 12px;">Class Name:</h6>
                      <p class="card-text mb-0 ml-1">
                        {{ class_details.name }}
                      </p>
                    </div>
                  </div>
                </div>
  
                <div class="sm:w-1/2 w-full my-2">
                  <div class="flex items-center my-2 mr-3">
                    <div class="badge-avatar">
                      <span class="material-icons-outlined">local_library</span>
                    </div>
                    <div class="ml-2">
                      <h6 style="font-size: 12px;">Teacher Name:</h6>
                      <p class="card-text mb-0 ml-1">
                        {{ class_details.class_teacher_name }}
                      </p>
                    </div>
                  </div>
                </div>
  
                <div class="sm:w-1/2 w-full my-2">
                  <div class="flex items-center my-2 mr-3">
                    <div class="badge-avatar">
                      <span class="material-icons-outlined">pending_actions</span>
                    </div>
                    <div class="ml-2">
                      <h6 style="font-size: 12px;">Session Name:</h6>
                      <p class="card-text mb-0 ml-1">
                        {{ class_details.term }}
                      </p>
                    </div>
                  </div>
                </div>
  
                <div class="sm:w-1/2 w-full my-2">
                  <div class="flex items-center mr-3">
                    <div class="badge-avatar">
                      <span class="material-icons-outlined">sticky_note_2</span>
                    </div>
                    <div class="ml-2">
                      <h6 style="font-size: 12px;">Subject Name:</h6>
                      <p class="card-text mb-0 ml-1">
                        {{ subject_name  || "Not Available"}}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      
      
        <div class="flex flex-wrap items-center">
          <div class="inform-meetup-holder sm:w-1/2 w-full sm:pr-2 pr-0 my-2">
            <div class="badge-avatar">
              <span class="material-icons">date_range</span>
            </div>
            <div>
              <h6 style="font-size: 12px;">Session Duration</h6>
                <p>
                  {{
                    $moment(
                      class_details.start_date
                    ).format('DD/MM/YYYY')
                  }}
                  -
                  {{
                    $moment(
                      class_details.end_date
                    ).format('DD/MM/YYYY')
                  }}
                </p>
            </div>
          </div>
          <div class="inform-meetup-holder sm:w-1/2 w-full sm:pr-2 pr-0 my-2">
            <div class="badge-avatar">
              <span class="material-icons-outlined">schedule</span>
            </div>
            <div>
              <h6 style="font-size: 12px;">Period timing</h6>
              <p
                >{{
                  eventDetails.extendedProps.course.schedule_from_time.slice(0, -3)
                }}
                -
                {{
                  eventDetails.extendedProps.course.schedule_to_time.slice(0, -3)
                }}</p
              >
            </div>
          </div>
        </div>
    </section>
    </div>
  </template>

<script>
import {classDetailsFetch, classSubjectFetch} from '@/api/schedulerApi.js'
export default {
  props:{
    classPopup:{},
    class_id:{},
    eventDetails:{},
    class_details:null,
    subject_name:''
  },
  data () {
    return {

    }
  },
  mounted () {
    this.fetchClassDetails()
    console.log(this.eventDetails)
  }, 
  methods: {
    async fetchClassDetails () {
      const {data} = await classDetailsFetch(this.class_id, localStorage.getItem('customer_id'))
      this.class_details = data.data.classes

      const payload = {
        class_id : this.class_id,
        schedule_id:  this.eventDetails.id
      }
      const {data1} = await classSubjectFetch(localStorage.getItem('customer_id'), payload)
      this.subject_name = data1.data.period
    }
  }
}
</script>
  <style>
  .color-holder {
    width: 100%;
    height: 30px;
    border-radius: 5px;
  }
  .vs-tooltip {
    z-index: 100000;
  }
  .meetup-header {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    position: relative;
  }
  .meetup_inner_holder {
    width: calc(100% - 38px);
    display: flex;
    /* flex-wrap: wrap; */
  }
  .editable_holder {
    position: absolute;
    top: 0;
    right: 0;
  }
  .meetup-header .meetup-day {
    border-right: 1px solid #d8d6de;
    padding-right: 1.3rem;
    margin-right: 1.3rem;
    text-align: center;
  }
  .meetup-header .card-title {
    font-weight: 500;
    font-size: 1.285rem;
    display: inline-block;
  }
  .inform-meetup-holder {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }
  .inform-meetup-holder .badge-avatar {
    margin-right: 14px;
  }
  .status_main_holder {
    position: relative;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(65, 207, 221, 0.12);
    border-radius: 5px;
    margin: 0 15px 10px 0;
    cursor: pointer;
  }
  .status_main_holder.active {
    box-shadow: 0 4px 25px rgba(0, 0, 0, 0.2);
    transform: scale(1.12);
  }
  .status_main_holder .status_icon_holder {
    position: absolute;
    top: -8px;
    right: -8px;
  }
  .status_main_holder .status_icon_holder .check {
    color: rgba(var(--vs-success), 1);
    font-size: 20px;
  }
  .status_main_holder .status_icon_holder .error {
    color: rgba(var(--vs-warning), 1);
    font-size: 20px;
  }
  </style>